<template lang="">
  <div style="margin-bottom: 30px;">
    <el-form ref="ruleForm" :rules="rules" :model="item" >
        <el-form-item prop="fileDesc">
          <uploadPicView :list="list" :index="index" :data="data" :item="item" />
          <div style="height: 40px;position:relative;margin-top: 6px;">
            <el-input maxlength="20" size="mini" v-model.trim="item.fileDesc" placeholder="请输入图片描述" style="margin-bottom:10px;width:120px"></el-input>
          </div>
        </el-form-item>
    </el-form>
  </div>
</template>
<script>
import uploadPicView from '@/components/product_control/addProductDialog/uploadPicView'
import eventBus from '@/assets/js/eventBus'
export default {
  props: {
    data: {
      type: Object
    },
    list: {
      type: Array
    },
    item: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  created () {
    eventBus.$on('validatePicList', this.validatePicList)// 验证表单
    eventBus.$on('resetFields', this.resetFields)// 重置表单
  },
  data () {
    return {
      rules: {
        fileDesc: [
          { required: false, message: '请输入图片描述', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    uploadPicView
  },
  methods: {
    resetFields () {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    validatePicList () {
      this.$refs.ruleForm && this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          this.data.validate = false;
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-form-item__content {
  line-height: inherit !important;
  margin-bottom: 10px;
}
/deep/ .el-upload{
  border: 1px dashed #d9d9d9;
}
/deep/.avatar-uploader {
    width: 100px;
    height: 100px;
}
/deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar-uploader-icon {
     font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
</style>
